export default {
  namespaced: true,
  state: {
    dictionary: {},
    queue: -50,
    counter: 0,
  },
  mutations: {
    setTranslation(state, data) {
      state.dictionary[data.key] = data.value;
    },
  },
  actions: {
    async actionTranslatePhrase(
      {commit, dispatch, state, rootState},
      sourcePhrase,
    ) {
      function sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
      }

      if (!rootState.user?.preferences?.locale) {
        do {
          state.counter += 1;
          await sleep(100);
        } while (!rootState.user?.preferences?.locale && state.counter < 50);
      }

      const locale = rootState.user?.preferences?.locale || 'fr-FR';

      if (locale === 'fr-FR') {
        // avoid call  if no need to translate
        return sourcePhrase;
      }
      state.queue += 50; // to avoid DDos with the same requests
      await sleep(state.queue);

      const savedTranslation = state.dictionary[`${sourcePhrase}_${locale}`];
      if (savedTranslation) {
        // read from cache
        state.queue -= 50;
        return savedTranslation;
      }
      try {
        const translatedPhrase = await dispatch(
          'actionWeglotTranslate',
          sourcePhrase,
        );
        state.queue -= 50;
        commit('setTranslation', {
          key: `${sourcePhrase}_${locale}`,
          value: translatedPhrase,
        });
        return translatedPhrase;
      } catch (error) {
        console.error('Translation failed:', error);
        return sourcePhrase; // Fallback to source phrase on error
      }
    },
    /**
     * Wrapper function for window.Weglot.translate
     * @param {string} sourcePhrase - The phrase to be translated
     * @returns {Promise<string>} - A promise that resolves to the translated phrase or source phrase
     */
    async actionWeglotTranslate(_commit, sourcePhrase) {
      return new Promise((resolve) => {
        if (!window.Weglot || !window.Weglot.translate) {
          console.error('Weglot is not initialized.');
          resolve(sourcePhrase); // Fallback to source phrase
          return;
        }

        window.Weglot.translate(
          {
            words: [{t: 1, w: sourcePhrase}],
          },
          (data) => {
            if (data && data[0].length > 0) {
              resolve(data[0]); // Return the translated phrase
            } else {
              resolve(sourcePhrase); // Fallback to source phrase if no translation
            }
          },
        );
      });
    },
  },
};
